import React, { useEffect, useRef, useState } from 'react';

export const getYoutubeVideoDurationThumnail = (videoId: string) => {
  return getYouTubeThumbnail(videoId);
};
const getYouTubeThumbnail = (videoId: string): string => {
  return `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg`;
};
